/**
 * Background polling interval for notification queries (bell badge + page list).
 * Kept relatively long for peak portal load; refresh also happens on tab focus.
 */
export const NOTIFICATIONS_REFETCH_INTERVAL_MS = 120_000;

/** Unread notifications fetched for the bell badge + dropdown preview. */
export const NOTIFICATIONS_BELL_UNREAD_PAGE_SIZE = 50;
